import { render, staticRenderFns } from "./m_chineseplus_live2023.vue?vue&type=template&id=45b0070e&scoped=true"
import script from "./m_chineseplus_live2023.vue?vue&type=script&lang=js"
export * from "./m_chineseplus_live2023.vue?vue&type=script&lang=js"
import style0 from "./m_chineseplus_live2023.vue?vue&type=style&index=0&id=45b0070e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0070e",
  null
  
)

export default component.exports